<template>
    <div class="wrap">
        <div class="container">
            <van-row class="yhbg" type="flex" align="center" justify="start" v-if="user_info">
                <van-col class="yh_tx">
                    <van-image round width="60" height="60" :src="user_info.avatar"/>
                </van-col>
                <van-col>
                    <p class="yh_name">Hi: {{user_info.nickname}}</p>
                    <p>邮箱: {{user_info.email}}</p>
                </van-col>
            </van-row>
            <van-row class="yhbg" type="flex" align="center" justify="start" v-if="!user_info">
                <van-col class="yh_tx">
                    <van-image round width="60" height="60" src="https://www.xiangzh.com/images/morenimg.png" />
                </van-col>
                <van-col>
                    <p class="yh_name">
                      <router-link to="/login">请登录</router-link>
                    </p>                    
                    <p></p>
                </van-col>
            </van-row>

            <div class="per_list">
                <van-cell is-link to="/myprofile">
                    <template #title>
                        <van-row type="flex" align="center">
                        <span class="iconfont icon-weibiaoti3"></span>
                      <span class="custom-title">我的个人资料</span>
                    </van-row>
                    </template>
                  </van-cell>
                  <van-cell is-link to="/address">
                    <template #title>
                        <van-row type="flex" align="center">
                        <span class="iconfont icon-dingdan"></span>
                      <span class="custom-title"> 我的地址</span>
                    </van-row>
                    </template>
                  </van-cell>
                  <van-cell is-link to="/changepasd">
                    <template #title>
                        <van-row type="flex" align="center">
                        <span class="iconfont icon-mima"></span>
                      <span class="custom-title">修改密码</span>
                    </van-row>
                    </template>
                  </van-cell>
                  <van-cell is-link to="/voucher">
                    <template #title>
                        <van-row type="flex" align="center">
                        <span class="iconfont icon-youhuiquan"></span>
                      <span class="custom-title">我的优惠券</span>
                    </van-row>
                    </template>
                  </van-cell>
                  <van-cell is-link to="/Orders">
                    <template #title>
                        <van-row type="flex" align="center">
                        <span class="iconfont icon-dingdan"></span>
                      <span class="custom-title">我的订单</span>
                    </van-row>
                    </template>
                  </van-cell>
                  <van-cell is-link to="/reviews">
                    <template #title>
                        <van-row type="flex" align="center">
                        <span class="iconfont icon-review"></span>
                      <span class="custom-title">我的评论</span>
                    </van-row>
                    </template>
                  </van-cell>
                  <!-- <van-cell is-link to="/wishlist">
                    <template #title>
                        <van-row type="flex" align="center">
                      <span class="iconfont icon-aixin"></span>
                      <span class="custom-title">My Wishlist</span>
                    </van-row>
                    </template>
                  </van-cell> -->
                  <van-cell value="" />
            </div>
            <van-row type="flex" align="center" justify="center">
              <van-col span="8">
                <van-button block size="small" type="default" v-on:click="logout()">退出</van-button>
              </van-col>
            </van-row>
        </div>
        <coupons-box v-if="user_coupons.length > 0" :user_coupons="user_coupons" :source="'close'"></coupons-box>
        <v-foot></v-foot>
    </div>
</template>
<script>
    export default {
        components: {},
        created(){
			this.user_info = this.getUserInfo(true);
        },
        data() {
            return {
                "user_info":false,
                user_coupons: [],
                reg: ''
            }
        },
        methods: {
			logout(){
				var _this = this;
				this.POST("api/user/loginout",{},function(d){
					window.console.log(d);
					_this.$router.push('login');
				});
				this.setUserInfo(-1);
			},
        },
    }
</script>